var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "drawer-panel-inner" }, [
    _c("div", { staticClass: "drawer-panel-inner__head" }, [
      _vm.showBack
        ? _c(
            "button",
            {
              staticClass: "drawer-panel-inner__back",
              on: { click: _vm.back }
            },
            [
              _c("f-sprite-icon", {
                attrs: { "icon-link": _vm.$options.icons.IconBack.id }
              })
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "drawer-panel-inner__title" }, [
        _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")
      ]),
      _c(
        "button",
        { staticClass: "drawer-panel-inner__close", on: { click: _vm.close } },
        [
          _c("f-sprite-icon", {
            attrs: { "icon-link": _vm.$options.icons.IconClose.id }
          })
        ],
        1
      )
    ]),
    _c(
      "div",
      { staticClass: "drawer-panel-inner__content" },
      [_vm._t("default")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }